export const SharedText = {
  CountryCodeSelect: {
    ariaLabel: 'Country code',
  },
  ShowPasswordButton: {
    ariaLabel: {
      showPassword: 'Show password',
      hidePassword: 'Hide password',
    },
  },
  Fields: {
    ariaLabel: {
      clearField: 'Clear search',
    },
  },
  SearchField: {
    ariaLabel: {
      search: 'Search',
    },
  },
  StepperField: {
    ariaLabel: {
      IncreaseTo: 'Increase to',
      DecreaseTo: 'Decrease to',
    },
  },
  Collection: {
    SearchFieldLabel: 'Search',
  },
};
